import { Title } from "./style"

const PageTitle = ({title}) => {
    return(
            <Title>{title}</Title>
    )
};

export default PageTitle;